import { render } from "./SchemaOverridesEditor.vue?vue&type=template&id=02c52deb&scoped=true"
import script from "./SchemaOverridesEditor.vue?vue&type=script&lang=ts"
export * from "./SchemaOverridesEditor.vue?vue&type=script&lang=ts"

import "./SchemaOverridesEditor.vue?vue&type=style&index=0&id=02c52deb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02c52deb"

export default script